// extracted by mini-css-extract-plugin
export var dividerLine = "_7k-3";
export var itemImage = "_7k-9";
export var lightDivider = "_7k-4";
export var modalContent = "_7k-5";
export var modalContentCompact = "_7k-6";
export var productCard = "_7k-a";
export var productImage = "_7k-b";
export var productImageCompact = "_7k-7";
export var productImagePlaceholder = "_7k-c";
export var productImagePlaceholderCompact = "_7k-8";
export var progressBarBackground = "_7k-1";
export var progressBarContainer = "_7k-0";
export var progressBarFill = "_7k-2";